import {
  GDTApiErrors,
  Maybe,
  ChangeTacticAction,
  EnumPosition,
  Sugerencias,
  PlayerPositionAbbrF5,
  PlayerPositionAbbr,
} from '@/types';
import { JSX } from 'react';
import { InfoRanking } from './teamf5';

export const enum EnumTeamContext {
  Team11 = 'TEAM_11',
  Build11 = 'BUILD_11',
  Team5 = 'TEAM_5',
  Build5 = 'BUILD_5',
  Score11 = 'SCORE_11',
  Score5 = 'SCORE_5',
  FilterTeam11 = 'FILTER_LIST_11',
  FilterTeam5 = 'FILTER_LIST_5',
  FilterTeam = 'FILTER_LIST',
  MyTeam = 'MY_TEAM',
  Changes11 = 'CHANGES_11',
}

export const enum EnumContextGDT {
  MyAccount = 'MY_ACCOUNT',
  GoldDate = 'GOLD_DATE',
  Challenges = 'CHALLENGES',
  FriendTournament = 'FRIENDS_TOURNAMENTS',
  FriendsCup = 'FRIEND_CUP',
  Minileagues = 'MINILEAGUES',
  MinileaguesDisabled = 'MINILEAGUES_DISABLED',
  MiniLeaguesInProgress = 'MINILEAGUES_IN_PROGRESS',
  Challenge = 'CHALLENGE',
  Summary = 'SUMMARY',
}

export const enum EnumContextTourneys {
  Sidebar = 'SIDEBAR',
  MainContentHome = 'HOME',
  Admin = 'ADMIN',
  Playing = 'PLAYING',
  Create = 'CREATE',
  Reactivate = 'REACTIVATE',
  View = 'VIEW',
}

export interface Player extends PlayerClub {
  id: number;
  titular: boolean;
  capitan: boolean;
}

/* .. auto-generated by openapi-typescript.*/
export interface DraftTeam {
  /**
   * Format: int32
   * @description obvio
   */
  id: number;
  /**
   * version (optimistic lock)
   */
  version?: number;

  /** @description jugadores */
  jugadores: PlayerClub[];
  /**
   * Format: int32
   * @description suma de los precios de los jugadores seleccionados
   */
  importeTotal: number;
  /**
   * Format: byte
   * @description id de tÃ¡ctica <br> 1..9 segÃºn esta lista (ETipoFormacion): <br>	F_424((byte)8,"t4_2_4",new int[]{1,4,2,4}),
   * 	F_433((byte)2,"t4_3_3",new int[]{1,4,3,3}),
   * 	F_442((byte)1,"t4_4_2",new int[]{1,4,4,2}),
   * 	F_451((byte)4,"t4_5_1",new int[]{1,4,5,1}),
   *
   * 	F_334((byte)7,"t3_3_4",new int[]{1,3,3,4}),
   * 	F_343((byte)3,"t3_4_3",new int[]{1,3,4,3}),
   * 	F_352((byte)5,"t3_5_2",new int[]{1,3,5,2}),
   *
   * 	F_523((byte)9,"t5_2_3",new int[]{1,5,2,3}),
   * 	F_532((byte)6,"t5_3_2",new int[]{1,5,3,2}),
   */
  idTactica: number;
}

export interface ResponseGetInitDraftTeam {
  tieneEquipoBorrador?: boolean;
  nombreEquipo?: string;
  estado: true;
  equipoBorrador: DraftTeam;
  presupuestoTorneo: number;
}

export interface PlayerF5 {
  id?: number;
  orden?: number;
  capitan: boolean;
  posicion?: { nombreCorto: PlayerPositionAbbrF5; id: number };
  seguro?: boolean;
  codigo?: string;
  nombreCompleto?: string;
  club?: string;
  cotizacion?: number;
}

export interface ResponseGetInitBuildF5 {
  estado: true;
  mensaje: string;
  nombreEquipo?: string;
  equipo_f5: { jugadores: PlayerF5[]; importeTotal: number };
  esArmaEquipo: boolean;
}

/** @description Estructura de la respuesta del API para cada jugador */
export type TemplatePlayer = {
  id: number;
  a: string; //apellido
  n: string; // nombre
  c: number; // club
  p: number; // posicion
  cot: number; // cotizacion
  e: number; // estatus
  o: number; // puntos rankeado segun promedio de jugador (chequear)
  pm: string; // puntos promedio
  dts: number; // cantidad de dts f11 donde forma parte
  dtsF5: number; // cantidad de dts f5 donde forma parte
  pt: Maybe<number>; // puntos gdt
  pj: Maybe<number>; // partidos jugados
  fig: Maybe<number>; // veces figura
  gol: Maybe<number>; // cantidad de goles
  golPen: Maybe<number>; // cantidad de goles de penal
  valla: Maybe<number>; // cantidad de vallas invictas
  penAtaj: Maybe<number>; // penales atajados
  roj: Maybe<number>; // rojas recibidas
  ama: Maybe<number>; // amarillas recibidas
  eliminado: Maybe<boolean>; // jugador No mostrar en ningún listado
};

/** @description Estructura estructura de cada jugador o posicion vacia en cancha */
export interface PlayerClub {
  /**
   * Format: int32
   * @description id del jugador torneo (= datosIniciales.plantilla[].id)
   */
  id?: number;
  /**
   * Format: int32
   * @description orden dentro del equipo. <br>0 es el arquero, 1 el primer defensor..., 10 delantero, 11 primer arquero suplente, ...
   */
  orden: number;
  /** @description cÃ³digo Ãºnico. No necesario, preferir el id. */
  codigo?: string;
  /**
   * @description obvio
   * @example Juan RomÃ¡n Riquelme
   */
  nombreCompleto?: string;
  /**
   * @description obvio
   * @example River
   */
  club?: string;
  posicion?: Position;
  /**
   * Format: int32
   * @description costo del jugador (redundante)
   */
  cotizacion?: number;
  status?: StatusJugadorTO;
  /** @description es titular? (orden 1..11 es titular, 12..15 suplente) */
  titular: boolean;
  /** @description es el capitÃ¡n? (suma doble). SÃ³lo permitido si es titular. */
  capitan: boolean;
  /**
   * @description estadÃ­stica del jugador, ya formateado. (redundante?)
   * @example 8.1
   */
  puntosPromedio?: string;
  /**
   * Format: int32
   * @description estadÃ­stica del jugador (redundante?)
   * @example 3
   */
  partidosJugados?: number;
  seguro?: boolean;
}

/**
 * @description objeto posicion
 * @example {id: 1, nombre: 'Arquero', nombreCorto: 'ARQ'}
 */
interface Position {
  /** Format: int32 */
  id: number;
  nombre?: string;
  nombreCorto: PlayerPositionAbbr | PlayerPositionAbbrF5;
  /** Format: int32 */
  orden?: number;
}

export interface ResponseArmaEquipoGrabar {
  estado: true;
  ok: boolean;
  idEquipo: number;
  version: number;
  equipoBorrador?: DraftTeam;
}

/** No lo voy a leer, salvo que sea un error */
export interface ResponseFakeInicialToken extends GDTApiErrors {
  csrfToken: string;
}

/** @description status de jugador (habilitado,suspendido, etc) */
interface StatusJugadorTO {
  /**
   * Format: int32
   * @description obvio
   */
  id?: number;
  /**
   * @description obvio
   * @example SUSPENDIDO
   */
  nombre: string;
  /**
   * @description rgb en hexa, sin #, 6 dÃ­gitos
   * @example ffff88
   */
  color?: string;
}

/* .. auto-generated by openapi-typescript.*/

/** @description Request body (json) para guardar el equipo borrador */
export interface RequestEquipoBorrador {
  /**
   * Format: byte
   * @description id de prÃ³xima tÃ¡ctica. Ver mismo campo en GET.
   */
  idTactica: number;

  /** @description Jugadores. Notar que no es obligatorio que estÃ©n llenos. */
  jugadores: RequestJugadorEquipoBorrador[];
  /**
   * Format: int32
   * @description idUsuario. NO se usa para guardar. SÃ³lo se asegura de que coincida con el de la sesiÃ³n. Es para evitar un error por varias solapas abiertas con diferentes usuarios.
   */
  idUsuario: number;
}

export interface RequestAgregarJugadorF5 {
  idJugadorTorneo: number;
}

export interface RequestEliminarJugadorF5 {
  idJugadorTorneoSaliente: number;
}

export interface RequestDesignarCapitanJugadorF5 {
  idJugadorTorneo: number;
}

export interface RequestDesignarAseguradoJugadorF5 {
  idJugadorTorneo: number;
}

/** @description Jugadores. Notar que no es obligatorio que estÃ©n llenos. */
export interface RequestJugadorEquipoBorrador {
  /**
   * Format: int32
   * @description id del jugador torneo (= datosIniciales.plantilla[].id)
   */
  id?: number;
  /**
   * Format: int32
   * @description orden dentro del equipo. <br>0 es el arquero, 1 el primer defensor..., 10 delantero, 11 primer arquero suplente, ...
   */
  orden?: number;
  /** @description es el capitÃ¡n? (suma doble). SÃ³lo permitido si es titular. */
  capitan?: boolean;
}

export interface ResponseObtenerEquipoAnterior {
  /** @description obvio */
  estado: boolean;
  existe: boolean;
  equipoAnterior?: DraftTeam;
}

export interface ResponseEquipoConfirmado {
  estado: true;
  primeraFecha: boolean;
  torneo: string;
  ordenFechaFin: number;
  fechasJugables: number;
  txtFechasJugables: string;
  veda: boolean;
  ordenFecha: number;
  nombreFechaActiva: string;
  txtInicioVeda?: string;
}

export interface ResponseConfirmarEquipo {
  /**
   * Format: int32
   * @description orden de fecha en la que comienza (0..n)
   */
  ordenFechaInicioF11: number;
  estado: true;
  infoEquipoConfirmado: ResponseEquipoConfirmado;
}

export type PlayerDataComponentInField =
  | {
      data?: PlayerClub;
    }
  | undefined;

export type PlayerDataComponentInFieldF5 =
  | {
      data?: PlayerF5;
    }
  | undefined;

export type TacticOnField = {
  goalkeepers: Maybe<JSX.Element>;
  defenders: JSX.Element[];
  midfielders: JSX.Element[];
  forwards: JSX.Element[];
  substitutes: JSX.Element[];
};

export type PlayersOnFieldF5 = {
  goalkeeper: Maybe<JSX.Element>;
  fieldPlayers: JSX.Element[];
};

export type PlayerComponentInField = { props: PlayerDataComponentInField };
export type PlayerComponentInFieldF5 = { props: PlayerDataComponentInFieldF5 };

export type Step = {
  action: ChangeTacticAction;
  position: EnumPosition.DEF | EnumPosition.MID | EnumPosition.FWD;
  message: string;
};

export interface ResponseRankingHistoric {
  estado: boolean;
  puntaje: number;
  infoPuntajesUltimaFecha: InfoPuntajes;
  jugadores: PlayerHistoric[];
  infoPuntajes: InfoPuntajes;
  idTactica: number;
}

export interface InfoPuntajes extends InfoRanking {}

export interface PlayerHistoric extends PlayerClub {
  jugador: number;
  puntaje?: number;
}

export interface ResponseCurrentTeam {
  arraySugerenciaTO: Sugerencias[];
  cotizacion_equipo: string;
  deboOfrecerComodin: boolean;
  equipo: {
    jugadores: PlayerClub[];
    idTactica: number;
  };
  estado: true;
  prestamo_habilitado: boolean;
  prestamo_valor: number;
  recibio_prestamo: boolean;
  transferencias_fecha: number;
  proximaTransferenciaConPin: boolean;
  seLeDescontara1Pin: boolean;
  novedadDestacada?: NewsTeam;
  infoPuntajes: InfoPuntajes;
}

export interface NewsTeam {
  /**
   * Format: int32
   * @description legacy: si es 0 debe ignorarse. En apis nuevas no puede serlo.
   */
  id?: number;
  descripcion?: string;
  /** @description Indica que es la destacada de mi equipo. */
  destacada?: boolean;
  /**
   * @description No usar. Identificador del fondo del popup.
   * @enum {string}
   */
  fondo?: '1' | '2' | '3' | '4';
}

export interface RequestTransfer {
  /** Identificador único del jugador que va a ingresar al equipo */
  jugador_entra: number;
  /** Identificador único del jugador al cual se va a reemplazar */
  jugador_sale: number;
  /**
   * Indica el Punto de origen desde donde se realiza la transferencia:
   *
   * idTipoTransferencia = 0, Solapa Transferencias (operatoria normal)
   *
   * idTipoTransferencia = 1, Pop up Sugeridor - Jugadores en rojo
   *
   * idTipoTransferencia = 2, Pop up Sugeridor - Jugadores con bajo rendimiento en las últimas 3 fechas.
   */
  idTipoTransferencia?: number;
  /** Si correspondiera, envia el PIN a consumir para la transferencia */
  pin?: string;
}

export interface RequestNewCaptain {
  idCapitanNuevo: number;
  idCapitanActual: number;
}

export interface ResponseNewCaptain {
  /**
   * @description Indica el codigo de error cuando estado=false
   * (puede llegar a suceder que estado=false y este
   * campo no esté presente, en ese caso, habrá que
   * mostrar el error tal cual)
   * @example 18
   */
  codError?: number;
  /** @description estado==false es un error, sino es ok */
  estado: boolean;
  /** @description Descripción del mensaje de error cuando estado=false */
  mensaje?: string;
  transferencias_fecha?: number;
  cotizacion_equipo?: string;
  equipo?: {
    idTactica: number;
    jugadores: Player[];
  };
}

export interface ResponseTransfer extends ResponseNewCaptain {
  proximaTransferencia?: {
    proximaTransferenciaConPin: boolean;
    seLeDescontara1Pin: boolean;
  };
  pin_invalido?: boolean;
  requiere_pin?: boolean;
  saldo?: number;
  pinesDisponibles?: number;
}

export interface ResponseChangeTeam extends ResponseTransfer {}
export interface RequestChangeTeam extends RequestTransfer {}

export interface VariantFieldAssistance {
  variant?: 'DEFAULT' | 'EMBED';
}

/**
 * {
    "estado": true,
    "output": {
        "nya": "Pablo Foresto",
        "equipo": "e27435598",
        "puntajes": [
            {
                "edicion": 1,
                "nombreEquipo": "No Palermo's FC",
                "mejorFechaPorPuntos": {
                    "nroFecha": 10,
                    "ptos": 81
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 5,
                    "pos": 44294
                },
                "gral": {
                    "pos": 45457,
                    "ptos": 1106
                }
            },
            {
                "edicion": 2,
                "nombreEquipo": "Pablo",
                "mejorFechaPorPuntos": {
                    "nroFecha": 16,
                    "ptos": 113
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 16,
                    "pos": 22590
                },
                "gral": {
                    "pos": 23420,
                    "ptos": 1142
                }
            },
            {
                "edicion": 3,
                "nombreEquipo": "Pablo",
                "mejorFechaPorPuntos": {
                    "nroFecha": 18,
                    "ptos": 91
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 18,
                    "pos": 42082
                },
                "gral": {
                    "pos": 177403,
                    "ptos": 1123
                }
            },
            {
                "edicion": 4,
                "nombreEquipo": "Pablo",
                "mejorFechaPorPuntos": {
                    "nroFecha": 13,
                    "ptos": 96
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 13,
                    "pos": 16404
                },
                "gral": {
                    "pos": 38160,
                    "ptos": 1042
                }
            },
            {
                "edicion": 5,
                "nombreEquipo": "A la grande le puse cuca.",
                "mejorFechaPorPuntos": {
                    "nroFecha": 10,
                    "ptos": 99
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 10,
                    "pos": 13708
                },
                "gral": {
                    "pos": 10839,
                    "ptos": 1264
                }
            },
            {
                "edicion": 6,
                "nombreEquipo": "A la grande le puse cuca",
                "mejorFechaPorPuntos": {
                    "nroFecha": 16,
                    "ptos": 101
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 16,
                    "pos": 16201
                },
                "gral": {
                    "pos": 180042,
                    "ptos": 1056
                }
            },
            {
                "edicion": 7,
                "nombreEquipo": "A la grande le puse cuca.",
                "mejorFechaPorPuntos": {
                    "nroFecha": 6,
                    "ptos": 94
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 4,
                    "pos": 156937
                },
                "gral": {
                    "pos": 274863,
                    "ptos": 1173
                }
            },
            {
                "edicion": 8,
                "nombreEquipo": "A la grande le puse cuca.",
                "mejorFechaPorPuntos": {
                    "nroFecha": 15,
                    "ptos": 92
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 15,
                    "pos": 55726
                },
                "gral": {
                    "pos": 189002,
                    "ptos": 1051
                }
            },
            {
                "edicion": 9,
                "nombreEquipo": "A la grande le puse cuca.",
                "mejorFechaPorPuntos": {
                    "nroFecha": 19,
                    "ptos": 107
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 15,
                    "pos": 29357
                },
                "gral": {
                    "pos": 186318,
                    "ptos": 1200
                }
            },
            {
                "edicion": 10,
                "nombreEquipo": "A la grande le puse cuca.",
                "mejorFechaPorPuntos": {
                    "nroFecha": 12,
                    "ptos": 99
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 12,
                    "pos": 57176
                },
                "gral": {
                    "pos": 370186,
                    "ptos": 1060
                }
            },
            {
                "edicion": 11,
                "nombreEquipo": "A la grande le puse cuca.",
                "mejorFechaPorPuntos": {
                    "nroFecha": 6,
                    "ptos": 103
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 6,
                    "pos": 7349
                },
                "gral": {
                    "pos": 87878,
                    "ptos": 1142
                }
            },
            {
                "edicion": 12,
                "nombreEquipo": "A la grande le puse cuca",
                "mejorFechaPorPuntos": {
                    "nroFecha": 19,
                    "ptos": 104
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 18,
                    "pos": 25021
                },
                "gral": {
                    "pos": 48440,
                    "ptos": 1167
                }
            },
            {
                "edicion": 13,
                "nombreEquipo": "A la grande le puse cuca",
                "mejorFechaPorPuntos": {
                    "nroFecha": 16,
                    "ptos": 118
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 16,
                    "pos": 4578
                },
                "gral": {
                    "pos": 13516,
                    "ptos": 1336
                }
            },
            {
                "edicion": 14,
                "nombreEquipo": "A la grande le puse cuca",
                "mejorFechaPorPuntos": {
                    "nroFecha": 12,
                    "ptos": 97
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 12,
                    "pos": 30225
                },
                "gral": {
                    "pos": 114662,
                    "ptos": 941
                }
            },
            {
                "edicion": 15,
                "nombreEquipo": "A la grande le puse cuca",
                "mejorFechaPorPuntos": {
                    "nroFecha": 27,
                    "ptos": 109
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 29,
                    "pos": 13723
                },
                "gral": {
                    "pos": 25167,
                    "ptos": 1142
                }
            },
            {
                "edicion": 16,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 8,
                    "ptos": 110
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 8,
                    "pos": 9940
                },
                "gral": {
                    "pos": 22854,
                    "ptos": 1060
                }
            },
            {
                "edicion": 17,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 9,
                    "ptos": 112
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 9,
                    "pos": 4328
                },
                "gral": {
                    "pos": 73759,
                    "ptos": 999
                }
            },
            {
                "edicion": 18,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 23,
                    "ptos": 143
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 23,
                    "pos": 371
                },
                "gral": {
                    "pos": 9235,
                    "ptos": 1190
                }
            },
            {
                "edicion": 19,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 4,
                    "ptos": 102
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 8,
                    "pos": 8330
                },
                "gral": {
                    "pos": 42790,
                    "ptos": 869
                }
            },
            {
                "edicion": 20,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 26,
                    "ptos": 105
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 27,
                    "pos": 879
                },
                "gral": {
                    "pos": 27708,
                    "ptos": 990
                }
            },
            {
                "edicion": 21,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 3,
                    "ptos": 118
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 3,
                    "pos": 1209
                },
                "gral": {
                    "pos": 2077,
                    "ptos": 1118
                }
            },
            {
                "edicion": 22,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 21,
                    "ptos": 100
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 21,
                    "pos": 4646
                },
                "gral": {
                    "pos": 43796,
                    "ptos": 868
                }
            },
            {
                "edicion": 23,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 9,
                    "ptos": 102
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 9,
                    "pos": 12967
                },
                "gral": {
                    "pos": 95219,
                    "ptos": 955
                }
            },
            {
                "edicion": 24,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 20,
                    "ptos": 91
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 20,
                    "pos": 9929
                },
                "gral": {
                    "pos": 33314,
                    "ptos": 413
                }
            },
            {
                "edicion": 25,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 7,
                    "ptos": 86
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 7,
                    "pos": 1955
                },
                "gral": {
                    "pos": 29787,
                    "ptos": 563
                }
            },
            {
                "edicion": 26,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 5,
                    "ptos": 89
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 14,
                    "pos": 38184
                },
                "gral": {
                    "pos": 117876,
                    "ptos": 710
                }
            },
            {
                "edicion": 27,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 20,
                    "ptos": 138
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 20,
                    "pos": 289
                },
                "gral": {
                    "pos": 27616,
                    "ptos": 1325
                }
            },
            {
                "edicion": 28,
                "nombreEquipo": "A la grande le puse cuca..",
                "mejorFechaPorPuntos": {
                    "nroFecha": 13,
                    "ptos": 128
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 14,
                    "pos": 2974
                },
                "gral": {
                    "pos": 48500,
                    "ptos": 922
                }
            },
            {
                "edicion": 29,
                "nombreEquipo": "kljkljklááááá",
                "mejorFechaPorPuntos": {
                    "nroFecha": 17,
                    "ptos": 99
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 6,
                    "pos": 18105
                },
                "gral": {
                    "pos": 62832,
                    "ptos": 1273
                }
            },
            {
                "edicion": 30,
                "nombreEquipo": "kljkljklááááá",
                "mejorFechaPorPuntos": {
                    "nroFecha": 9,
                    "ptos": 106
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 20,
                    "pos": 13335
                },
                "gral": {
                    "pos": 49353,
                    "ptos": 1464
                }
            },
            {
                "edicion": 31,
                "nombreEquipo": "kljkljkláááááñ",
                "mejorFechaPorPuntos": {
                    "nroFecha": 6,
                    "ptos": 96
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 12,
                    "pos": 13582
                },
                "gral": {
                    "pos": 58570,
                    "ptos": 797
                }
            },
            {
                "edicion": 32,
                "nombreEquipo": "kljkljkláááááñ",
                "mejorFechaPorPuntos": {
                    "nroFecha": 12,
                    "ptos": 100
                },
                "mejorFechaPorPosicion": {
                    "nroFecha": 11,
                    "pos": 4273
                },
                "gral": {
                    "pos": 12868,
                    "ptos": 817
                }
            }
        ],
        "ediciones": [
            {
                "edicion": 1,
                "nombreEdicion": "Apertura 2008",
                "cantParticipantesEdicion": 2050123
            },
            {
                "edicion": 2,
                "nombreEdicion": "Clausura 2009",
                "cantParticipantesEdicion": 2111016
            },
            {
                "edicion": 3,
                "nombreEdicion": "Apertura 2009",
                "cantParticipantesEdicion": 1738962
            },
            {
                "edicion": 4,
                "nombreEdicion": "Clausura 2010",
                "cantParticipantesEdicion": 1516430
            },
            {
                "edicion": 5,
                "nombreEdicion": "Apertura 2010",
                "cantParticipantesEdicion": 1550363
            },
            {
                "edicion": 6,
                "nombreEdicion": "Clausura 2011",
                "cantParticipantesEdicion": 1441209
            },
            {
                "edicion": 7,
                "nombreEdicion": "Apertura 2011",
                "cantParticipantesEdicion": 1458003
            },
            {
                "edicion": 8,
                "nombreEdicion": "Clausura 2012",
                "cantParticipantesEdicion": 1128575
            },
            {
                "edicion": 9,
                "nombreEdicion": "Inicial 2012",
                "cantParticipantesEdicion": 1284122
            },
            {
                "edicion": 10,
                "nombreEdicion": "Final 2013",
                "cantParticipantesEdicion": 1064254
            },
            {
                "edicion": 11,
                "nombreEdicion": "Inicial 2013",
                "cantParticipantesEdicion": 833018
            },
            {
                "edicion": 12,
                "nombreEdicion": "Final 2014",
                "cantParticipantesEdicion": 644888
            },
            {
                "edicion": 13,
                "nombreEdicion": "Primera División 2014 (transición)",
                "cantParticipantesEdicion": 621230
            },
            {
                "edicion": 14,
                "nombreEdicion": "Primera División 2015",
                "cantParticipantesEdicion": 672533
            },
            {
                "edicion": 15,
                "nombreEdicion": "Primera División 2015(2)",
                "cantParticipantesEdicion": 351328
            },
            {
                "edicion": 16,
                "nombreEdicion": "Primera División 2016 (transición)",
                "cantParticipantesEdicion": 420457
            },
            {
                "edicion": 17,
                "nombreEdicion": "Primera División 2016/17",
                "cantParticipantesEdicion": 396426
            },
            {
                "edicion": 18,
                "nombreEdicion": "Primera División 2016/17 (2)",
                "cantParticipantesEdicion": 379371
            },
            {
                "edicion": 19,
                "nombreEdicion": "Primera División 2017/18 (1)",
                "cantParticipantesEdicion": 372568
            },
            {
                "edicion": 20,
                "nombreEdicion": "Primera División 2017/18 (2)",
                "cantParticipantesEdicion": 259387
            },
            {
                "edicion": 21,
                "nombreEdicion": "Primera División 2018/19",
                "cantParticipantesEdicion": 287898
            },
            {
                "edicion": 22,
                "nombreEdicion": "Primera División 2018/19 (2)",
                "cantParticipantesEdicion": 234048
            },
            {
                "edicion": 23,
                "nombreEdicion": "Primera División 2019/20",
                "cantParticipantesEdicion": 286477
            },
            {
                "edicion": 24,
                "nombreEdicion": "Primera División 2019/20 (2)",
                "cantParticipantesEdicion": 210874
            },
            {
                "edicion": 25,
                "nombreEdicion": "Copa de Liga 2020",
                "cantParticipantesEdicion": 161198
            },
            {
                "edicion": 26,
                "nombreEdicion": "Copa de Liga 2021",
                "cantParticipantesEdicion": 244082
            },
            {
                "edicion": 27,
                "nombreEdicion": "Primera División 2021",
                "cantParticipantesEdicion": 202879
            },
            {
                "edicion": 28,
                "nombreEdicion": "Copa de Liga 2022",
                "cantParticipantesEdicion": 262754
            },
            {
                "edicion": 29,
                "nombreEdicion": "Primera División 2022",
                "cantParticipantesEdicion": 210041
            },
            {
                "edicion": 30,
                "nombreEdicion": "Primera División 2023",
                "cantParticipantesEdicion": 236845
            },
            {
                "edicion": 31,
                "nombreEdicion": "Copa de Liga 2023",
                "cantParticipantesEdicion": 143084
            },
            {
                "edicion": 32,
                "nombreEdicion": "Primera División 2024",
                "cantParticipantesEdicion": 161029
            }
        ]
    }
}*/
export interface ResponseMyCampaings extends GDTApiErrors {
  output: {
    nya: string;
    equipo: string;
    puntajes: {
      edicion: number;
      nombreEquipo: string;
      mejorFechaPorPuntos: {
        nroFecha: number;
        ptos: number;
      };
      mejorFechaPorPosicion: {
        nroFecha: number;
        pos: number;
      };
      gral: {
        pos: number;
        ptos: number;
      };
    }[];
    ediciones: {
      edicion: number;
      nombreEdicion: string;
      cantParticipantesEdicion: number;
    }[];
  };
}
